import { useState, useEffect, useRef } from "react";

// ── Brand tokens ──────────────────────────────────────────────────────────────
const C = {
  darkGreen:  "#052C0C",
  limeGreen:  "#9ACA44",
  oliveGreen: "#819951",
  cream:      "#1D2C1E",
  white:      "#102216",
  darkBg:     "#FFFFFF",
  cardBg:     "#F7FAF4",
  border:     "rgba(5,44,12,0.16)",
  textFaint:  "rgba(16,34,22,0.72)",
  textMid:    "rgba(16,34,22,0.86)",
};

const NAV_LINKS = ["#/About", "#/Contact", "#/FAQ"];
// const LOGO_SRC  = "/wp-content/themes/satp/assets/logo.png"; // ← update this path
const LOGO_SRC = "https://syntropypro.com/wp-content/uploads/2026/04/SATFPM-LOGO-1.png";

// ── WP REST endpoint for contact form submission ──────────────────────────────
// Register in WordPress: POST /wp-json/satp/v1/contact
// Expected body: { name, email, subject, message }
const WP_CONTACT_ENDPOINT = "https://syntropypro.com/wp-json/satp/v1/contact";

// ── Shared Header ─────────────────────────────────────────────────────────────
function Header({ scrolled, isMobile, menuOpen, setMenuOpen }) {
  return (
    // <header style={{
    //   position: "fixed", top: 0, left: 0, right: 0, zIndex: 999,
    //   display: "flex", flexDirection: isMobile ? "column" : "row",
    //   alignItems: isMobile ? "flex-start" : "center", justifyContent: "space-between",
    //   gap: isMobile ? 10 : 0,
    //   padding: scrolled ? (isMobile ? "10px 16px" : "10px 52px") : (isMobile ? "14px 16px" : "22px 52px"),
    //   background: "rgba(5,44,12,0.96)",
    //   backdropFilter: "blur(14px)",
    //   borderBottom: `1px solid ${C.border}`,
    //   transition: "all 0.4s cubic-bezier(0.4,0,0.2,1)",
    // }}>
    //   <a href="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
    //     <img src={LOGO_SRC} alt="SATP" style={{ height: scrolled ? 36 : 50, transition: "height 0.4s ease", filter: "drop-shadow(0 2px 8px rgba(154,202,68,0.25))" }} />
    //     <div>
    //       <div style={{ fontSize: scrolled ? 13 : 15, fontWeight: 700, letterSpacing: "0.06em", color: "#FFFFFF", lineHeight: 1.1, transition: "font-size 0.4s ease" }}>SYNTROPY</div>
    //       <div style={{ fontSize: scrolled ? 8 : 9, fontWeight: 500, letterSpacing: "0.25em", color: C.limeGreen, textTransform: "uppercase", transition: "font-size 0.4s ease" }}>ALLIANCE TRADE</div>
    //     </div>
    //   </a>
    //   <nav style={{ display: "flex", gap: isMobile ? 14 : 36, alignItems: "center", flexWrap: "wrap" }}>
    //     {NAV_LINKS.map((link) => {
    //       const label = link.replace(/#\//g, "");
    //       const isActive = label.toLowerCase() === "contact";
    //       return (
    //         <a key={link} href={`/${link.toLowerCase()}`}
    //           style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: isActive ? C.limeGreen : "rgba(230,203,161,0.7)", fontWeight: isActive ? 600 : 500, textDecoration: "none", transition: "color 0.2s" }}
    //           onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
    //           onMouseLeave={(e) => (e.target.style.color = isActive ? C.limeGreen : "rgba(230,203,161,0.7)")}>
    //           {label}
    //         </a>
    //       );
    //     })}
    //     <a key="affiliate-dashboard-link" href="affiliate-dashboard"
    //         style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(230,203,161,0.7)", fontWeight: 500, transition: "color 0.2s" }}
    //         onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
    //         onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.7)")}>
    //         Affiliate Dashboard
    //     </a>
    //     <a href="/shop" style={{ padding: "10px 24px", background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`, color: C.darkGreen, borderRadius: 3, fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", textDecoration: "none", display: "inline-block" }}>
    //       Shop Now
    //     </a>
    //   </nav>
    // </header>
    <header style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 999,
      background: "rgba(5,44,12,0.96)",
      backdropFilter: "blur(14px)",
      borderBottom: `1px solid ${C.borderFaint}`,
      transition: "all 0.4s cubic-bezier(0.4,0,0.2,1)",
    }}>
      {/* <a href="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
        <img
          src={LOGO_SRC}
          alt="SAT"
          style={{
            height: scrolled ? 36 : 50,
            transition: "height 0.35s ease",
            filter: "drop-shadow(0 2px 8px rgba(154,202,68,0.25))",
          }}
        />
        <div>
          <div style={{ fontSize: scrolled ? 13 : 15, fontWeight: 700, letterSpacing: "0.06em", color: "#FFFFFF", lineHeight: 1.1 }}>
            SYNTROPY
          </div>
          <div style={{ fontSize: scrolled ? 8 : 9, fontWeight: 500, letterSpacing: "0.25em", color: C.limeGreen, textTransform: "uppercase" }}>
            ALLIANCE TRADE
          </div>
        </div>
      </a> */}

      {/* Top bar: logo + burger (mobile) or logo + nav (desktop) */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: scrolled ? (isMobile ? "10px 16px" : "10px 52px") : (isMobile ? "14px 16px" : "22px 52px"),
          transition: "padding 0.4s cubic-bezier(0.4,0,0.2,1)",
        }}>
          {/* Logo */}
          <a href="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
            <img
              src={LOGO_SRC}
              alt="SAT"
              style={{
                height: scrolled ? 36 : 50,
                transition: "height 0.35s ease",
                filter: "drop-shadow(0 2px 8px rgba(154,202,68,0.25))",
              }}
            />
            <div>
              <div style={{ fontSize: scrolled ? 13 : 15, fontWeight: 700, letterSpacing: "0.06em", color: "#FFFFFF", lineHeight: 1.1 }}>
                SYNTROPY
              </div>
              <div style={{ fontSize: scrolled ? 8 : 9, fontWeight: 500, letterSpacing: "0.25em", color: C.limeGreen, textTransform: "uppercase" }}>
                ALLIANCE TRADE
              </div>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="desktop-nav" style={{ display: "flex", gap: 36, alignItems: "center" }}>
            {NAV_LINKS.map((link) => (
              <a key={link} href={`${link.toLowerCase()}`}
                style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(230,203,161,0.7)", fontWeight: 500, transition: "color 0.2s" }}
                onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
                onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.7)")}>
                {link.replace(/#\//g, "")}
              </a>
            ))}
            <a key="affiliate-dashboard-link" href="affiliate-dashboard"
              style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(230,203,161,0.7)", fontWeight: 500, transition: "color 0.2s" }}
              onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
              onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.7)")}>
              Affiliate Dashboard
            </a>
            <a href="/shop" style={{ padding: "10px 24px", background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`, color: C.darkGreen, borderRadius: 3, fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", textDecoration: "none", display: "inline-block" }}>
              Shop Now
            </a>
          </nav>

          {/* Burger Button (mobile only) */}
          <button
            className={`burger-btn${menuOpen ? " open" : ""}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {isMobile && menuOpen && (
          <nav style={{
            display: "flex",
            flexDirection: "column",
            gap: 0,
            borderTop: `1px solid rgba(154,202,68,0.12)`,
            animation: "slideDown 0.22s ease",
          }}>
            {NAV_LINKS.map((link) => (
              <a
                key={link}
                href={`${link.toLowerCase()}`}
                onClick={() => setMenuOpen(false)}
                style={{
                  fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase",
                  color: "rgba(230,203,161,0.75)", fontWeight: 500,
                  padding: "14px 20px",
                  borderBottom: `1px solid rgba(154,202,68,0.08)`,
                  transition: "color 0.2s, background 0.2s",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.color = C.limeGreen; e.currentTarget.style.background = "rgba(154,202,68,0.06)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(230,203,161,0.75)"; e.currentTarget.style.background = "transparent"; }}
              >
                {link.replace(/#\//g, "")}
              </a>
            ))}
            <a
              href="affiliate-dashboard"
              onClick={() => setMenuOpen(false)}
              style={{
                fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase",
                color: "rgba(230,203,161,0.75)", fontWeight: 500,
                padding: "14px 20px",
                borderBottom: `1px solid rgba(154,202,68,0.08)`,
                transition: "color 0.2s, background 0.2s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.color = C.limeGreen; e.currentTarget.style.background = "rgba(154,202,68,0.06)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(230,203,161,0.75)"; e.currentTarget.style.background = "transparent"; }}
            >
              Affiliate Dashboard
            </a>
            <div style={{ padding: "14px 20px" }}>
              <a
                href="/shop"
                onClick={() => setMenuOpen(false)}
                style={{
                  display: "block", textAlign: "center",
                  padding: "12px 24px",
                  background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`,
                  color: C.darkGreen, borderRadius: 3,
                  fontSize: 12, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase",
                }}
              >
                Shop Now
              </a>
            </div>
          </nav>
        )}
    </header>
  );
}

// ── Contact info cards data ───────────────────────────────────────────────────
const CONTACT_ITEMS = [
  {
    icon: "📍",
    title: "Visit Us",
    lines: ["Syntropy Alliance Trade HQ", "123 Green Valley Avenue", "Cagayan de Oro, 9000", "Northern Mindanao, Philippines"],
  },
  {
    icon: "📞",
    title: "Call Us",
    lines: ["+63 (88) 123-4567", "+63 917 000 0000", "Mon–Fri, 8:00 AM – 6:00 PM PHT"],
  },
  {
    icon: "✉️",
    title: "Email Us",
    lines: ["hello@syntropytrade.com", "support@syntropytrade.com", "We reply within 24 hours"],
  },
  {
    icon: "💬",
    title: "Social & Chat",
    lines: ["@syntropytrade on Facebook", "@syntropytrade on Instagram", "Live chat available on our website"],
  },
];

const SUBJECTS = [
  "Product Inquiry",
  "Order Support",
  "Wholesale / Partnership",
  "Media & Press",
  "Careers",
  "General Feedback",
  "Other",
];

const INITIAL_FORM = { name: "", email: "", phone: "", subject: "", message: "" };

// ── Input styling factory ─────────────────────────────────────────────────────
const inputStyle = (focused) => ({
  width: "100%",
  padding: "14px 18px",
  background: focused ? "rgba(154,202,68,0.12)" : "#FFFFFF",
  border: `1px solid ${focused ? "rgba(154,202,68,0.6)" : C.border}`,
  borderRadius: 4,
  color: C.cream,
  fontSize: 14,
  fontFamily: "'Outfit', sans-serif",
  outline: "none",
  transition: "all 0.25s ease",
  appearance: "none",
});

// ── Main component ────────────────────────────────────────────────────────────
export default function ContactPage() {
  const [scrolled, setScrolled]     = useState(false);
  const [menuOpen, setMenuOpen]                           = useState(false);
  const [form, setForm]             = useState(INITIAL_FORM);
  const [focused, setFocused]       = useState({});
  const [submitStatus, setSubmit]   = useState("idle"); // "idle"|"sending"|"success"|"error"
  const [visibleSections, setVis]   = useState({});
  const [viewportWidth, setViewportWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  const sectionRefs = useRef({});
  const isMobile = viewportWidth <= 768;
  const isTablet = viewportWidth <= 1024;

  useEffect(() => {
    window.scrollTo(0, 0);

    const fn = () => setScrolled(window.scrollY > 70);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    const onResize = () => {
      setViewportWidth(window.innerWidth);
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) setVis((p) => ({ ...p, [e.target.dataset.section]: true }));
      }),
      { threshold: 0.1 }
    );
    Object.values(sectionRefs.current).forEach((el) => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const setRef  = (k) => (el) => { sectionRefs.current[k] = el; };
  const visible = (k) => visibleSections[k];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmit("sending");
    try {
      const res = await fetch(WP_CONTACT_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setSubmit("success");
      setForm(INITIAL_FORM);
    } catch (err) {
      console.error("Contact form error:", err);
      setSubmit("error");
    }
  };

  const sectionTag  = { fontSize: 11, letterSpacing: "0.28em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 14 };
  const sectionHead = { fontSize: "clamp(30px,4vw,52px)", fontWeight: 300, lineHeight: 1.18, color: C.white, marginBottom: 16, fontFamily: "'Playfair Display', serif" };
  const label       = { display: "block", fontSize: 11, letterSpacing: "0.16em", textTransform: "uppercase", color: "rgba(16,34,22,0.62)", marginBottom: 8, fontWeight: 500 };

  return (
    <div style={{ fontFamily: "'Outfit', 'Segoe UI', sans-serif", background: C.darkBg, color: C.cream, minHeight: "100vh", overflowX: "hidden" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,700;1,400&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @keyframes fadeUp { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
        @keyframes fadeIn { from{opacity:0} to{opacity:1} }
        @keyframes pulse  { 0%,100%{opacity:1} 50%{opacity:0.4} }
        body { background:${C.darkBg}; }
        ::-webkit-scrollbar{width:4px}
        ::-webkit-scrollbar-thumb{background:rgba(154,202,68,.3);border-radius:2px}
        a{text-decoration:none}
        .blob{position:absolute;border-radius:50%;filter:blur(90px);pointer-events:none}
        select option { background: #FFFFFF; color: #1D2C1E; }
        textarea { resize: vertical; min-height: 130px; }

        /* Burger button */
        .burger-btn {
          display: none;
          flex-direction: column;
          justify-content: center;
          gap: 5px;
          background: none;
          border: none;
          cursor: pointer;
          padding: 6px;
          z-index: 1001;
        }
        .burger-btn span {
          display: block;
          width: 22px;
          height: 2px;
          background: rgba(230,203,161,0.85);
          border-radius: 2px;
          transition: transform 0.3s ease, opacity 0.3s ease;
        }
        .burger-btn.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
        .burger-btn.open span:nth-child(2) { opacity: 0; }
        .burger-btn.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

        @media (max-width: 768px) {
          .burger-btn { display: flex; }
          .desktop-nav { display: none !important; }
        }
      `}</style>
      <Header scrolled={scrolled} isMobile={isMobile} menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      {/* ══════════════════════════════════════ HERO ── */}
      <section style={{ minHeight: "46vh", display: "flex", alignItems: "center", padding: isMobile ? "170px 20px 56px" : "140px 60px 80px", position: "relative", overflow: "hidden" }}>
        {/* <div className="blob" style={{ width: 600, height: 500, background: C.darkGreen, top: "-30%", right: "-10%", opacity: 0.6 }} /> */}
        {/* <div className="blob" style={{ width: 350, height: 350, background: C.limeGreen, bottom: "-20%", left: "5%", opacity: 0.06 }} /> */}
        <div style={{ display: isMobile ? "none" : "block", position: "absolute", left: 60, top: 0, bottom: 0, width: 1, background: `linear-gradient(to bottom,transparent,${C.limeGreen}44,transparent)` }} />

        <div style={{ position: "relative", maxWidth: 1180, margin: "0 auto", width: "100%" }}>
          <div style={{ ...sectionTag, animation: "fadeUp 0.7s ease both" }}>We'd Love to Hear From You</div>
          <h1 style={{ ...sectionHead, maxWidth: 600, animation: "fadeUp 0.8s 0.1s ease both" }}>
            Let's Start a <span style={{ color: C.limeGreen, fontStyle: "italic" }}>Conversation</span>
          </h1>
          <p style={{ fontSize: 16, lineHeight: 1.8, color: C.textFaint, maxWidth: 520, animation: "fadeUp 0.9s 0.2s ease both" }}>
            Whether you have a question about our products, want to explore a partnership, or just want to say hello — we're here and we listen.
          </p>
        </div>
      </section>

      {/* ══════════════════════════════════════ CONTACT CARDS ── */}
      <section style={{ padding: isMobile ? "0 20px 60px" : "0 60px 80px" }}
        ref={setRef("cards")} data-section="cards">
        <div style={{ maxWidth: 1180, margin: "0 auto", display: "grid", gridTemplateColumns: isMobile ? "1fr" : isTablet ? "repeat(2,1fr)" : "repeat(4,1fr)", gap: 20 }}>
          {CONTACT_ITEMS.map((item, i) => (
            <div key={item.title} style={{
              padding: "32px 26px", border: `1px solid ${C.border}`, borderRadius: 6, background: C.cardBg,
              opacity: visible("cards") ? 1 : 0,
              transform: visible("cards") ? "translateY(0)" : "translateY(24px)",
              transition: `opacity 0.5s ${i * 0.1}s ease, transform 0.5s ${i * 0.1}s ease`,
            }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(154,202,68,0.42)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = C.border; }}>
              <div style={{ fontSize: 28, marginBottom: 16 }}>{item.icon}</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: C.limeGreen, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 14 }}>{item.title}</div>
              {item.lines.map((line, j) => (
                <div key={j} style={{ fontSize: 13, lineHeight: 1.7, color: j === item.lines.length - 1 ? "rgba(16,34,22,0.48)" : C.textMid, marginBottom: j < item.lines.length - 1 ? 2 : 0, fontStyle: j === item.lines.length - 1 ? "italic" : "normal" }}>
                  {line}
                </div>
              ))}
            </div>
          ))}
        </div>
      </section>

      {/* ══════════════════════════════════════ FORM + MAP ── */}
      <section style={{ padding: isMobile ? "10px 20px 70px" : "20px 60px 100px" }}
        ref={setRef("form")} data-section="form">
        <div style={{ maxWidth: 1180, margin: "0 auto", display: "grid", gridTemplateColumns: isTablet ? "1fr" : "1fr 1fr", gap: isTablet ? 30 : 60, alignItems: "start" }}>

          {/* ── Contact Form ── */}
          <div style={{
            opacity: visible("form") ? 1 : 0,
            transform: visible("form") ? "translateX(0)" : "translateX(-30px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}>
            <div style={{ marginBottom: 36 }}>
              <div style={sectionTag}>Send a Message</div>
              <h2 style={{ ...sectionHead, fontSize: "clamp(26px,3vw,38px)" }}>
                We Reply Within <span style={{ color: C.limeGreen, fontStyle: "italic" }}>24 Hours</span>
              </h2>
              <p style={{ fontSize: 14, lineHeight: 1.75, color: C.textFaint }}>
                Fill out the form and one of our team members will get back to you as quickly as possible.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              {/* Name + Email row */}
              <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 16, marginBottom: 16 }}>
                <div>
                  <label style={label}>Full Name *</label>
                  <input
                    type="text" name="name" value={form.name} required
                    placeholder="Juan dela Cruz"
                    onChange={handleChange}
                    onFocus={() => setFocused((p) => ({ ...p, name: true }))}
                    onBlur={() => setFocused((p) => ({ ...p, name: false }))}
                    style={inputStyle(focused.name)}
                  />
                </div>
                <div>
                  <label style={label}>Email Address *</label>
                  <input
                    type="email" name="email" value={form.email} required
                    placeholder="you@email.com"
                    onChange={handleChange}
                    onFocus={() => setFocused((p) => ({ ...p, email: true }))}
                    onBlur={() => setFocused((p) => ({ ...p, email: false }))}
                    style={inputStyle(focused.email)}
                  />
                </div>
              </div>

              {/* Phone + Subject row */}
              <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 16, marginBottom: 16 }}>
                <div>
                  <label style={label}>Phone (optional)</label>
                  <input
                    type="tel" name="phone" value={form.phone}
                    placeholder="+63 900 000 0000"
                    onChange={handleChange}
                    onFocus={() => setFocused((p) => ({ ...p, phone: true }))}
                    onBlur={() => setFocused((p) => ({ ...p, phone: false }))}
                    style={inputStyle(focused.phone)}
                  />
                </div>
                <div>
                  <label style={label}>Subject *</label>
                  <select
                    name="subject" value={form.subject} required
                    onChange={handleChange}
                    onFocus={() => setFocused((p) => ({ ...p, subject: true }))}
                    onBlur={() => setFocused((p) => ({ ...p, subject: false }))}
                    style={{ ...inputStyle(focused.subject), cursor: "pointer" }}>
                    <option value="" disabled>Select a topic…</option>
                    {SUBJECTS.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>

              {/* Message */}
              <div style={{ marginBottom: 28 }}>
                <label style={label}>Message *</label>
                <textarea
                  name="message" value={form.message} required
                  placeholder="Tell us how we can help you…"
                  onChange={handleChange}
                  onFocus={() => setFocused((p) => ({ ...p, message: true }))}
                  onBlur={() => setFocused((p) => ({ ...p, message: false }))}
                  style={{ ...inputStyle(focused.message) }}
                />
              </div>

              {/* Submit button */}
              <button
                type="submit"
                disabled={submitStatus === "sending" || submitStatus === "success"}
                style={{
                  width: "100%", padding: "15px 24px",
                  background: submitStatus === "success"
                    ? `linear-gradient(135deg,${C.oliveGreen},${C.darkGreen})`
                    : `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`,
                  color: submitStatus === "success" ? C.cream : C.darkGreen,
                  border: "none", borderRadius: 4,
                  fontSize: 13, fontWeight: 700, letterSpacing: "0.12em",
                  textTransform: "uppercase", cursor: submitStatus === "sending" ? "wait" : "pointer",
                  fontFamily: "inherit",
                  transition: "all 0.3s ease",
                  opacity: submitStatus === "sending" ? 0.7 : 1,
                }}>
                {submitStatus === "idle"    && "Send Message →"}
                {submitStatus === "sending" && "Sending…"}
                {submitStatus === "success" && "✓ Message Sent!"}
                {submitStatus === "error"   && "Retry →"}
              </button>

              {/* Status messages */}
              {submitStatus === "success" && (
                <div style={{ marginTop: 16, padding: "14px 18px", background: "rgba(154,202,68,0.08)", border: `1px solid rgba(154,202,68,0.3)`, borderRadius: 4, fontSize: 14, color: C.limeGreen }}>
                  🎉 Thank you! We've received your message and will reply within 24 hours.
                </div>
              )}
              {submitStatus === "error" && (
                <div style={{ marginTop: 16, padding: "14px 18px", background: "rgba(255,80,80,0.06)", border: "1px solid rgba(255,80,80,0.25)", borderRadius: 4, fontSize: 14, color: "#ff8080" }}>
                  ⚠ Something went wrong. Please try again or email us directly at <strong>hello@syntropytrade.com</strong>.
                </div>
              )}

              {/* Privacy note */}
              <p style={{ marginTop: 16, fontSize: 11, color: "rgba(16,34,22,0.48)", lineHeight: 1.6 }}>
                By submitting this form you agree to our Privacy Policy. We will never share your information with third parties.
              </p>
            </form>
          </div>

          {/* ── Right panel: Map + Hours ── */}
          <div style={{
            opacity: visible("form") ? 1 : 0,
            transform: visible("form") ? "translateX(0)" : "translateX(30px)",
            transition: "opacity 0.6s 0.15s ease, transform 0.6s 0.15s ease",
            display: "flex", flexDirection: "column", gap: 24,
          }}>
            {/* Map embed placeholder */}
            <div style={{ position: "relative", width: "100%", aspectRatio: "4/3", borderRadius: 6, overflow: "hidden", border: `1px solid ${C.border}` }}>
              {/* Replace this iframe src with your actual Google Maps embed URL */}
              <iframe
                title="SATP Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124838.00786086735!2d124.5892527!3d8.4542363!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x32fff0a2b4b5e405%3A0x9cc0a1ccb9c6a76a!2sCagayan%20de%20Oro%2C%20Misamis%20Oriental!5e0!3m2!1sen!2sph!4v1700000000000!5m2!1sen!2sph"
                width="100%" height="100%" style={{ border: 0, filter: "invert(0.85) hue-rotate(120deg) saturate(0.6) brightness(0.75)" }}
                allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"
              />
              {/* Overlay pin label */}
              <div style={{ position: "absolute", bottom: 16, left: 16, background: "rgba(7,26,9,0.92)", border: `1px solid ${C.border}`, borderRadius: 4, padding: "10px 16px", backdropFilter: "blur(8px)" }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: C.limeGreen, letterSpacing: "0.1em" }}>SYNTROPY ALLIANCE TRADE</div>
                <div style={{ fontSize: 11, color: "rgba(230,203,161,0.75)", marginTop: 2 }}>Cagayan de Oro, Northern Mindanao</div>
              </div>
            </div>

            {/* Business hours */}
            <div style={{ padding: "28px 28px", border: `1px solid ${C.border}`, borderRadius: 6, background: C.cardBg }}>
              <div style={{ fontSize: 12, letterSpacing: "0.18em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 20, fontWeight: 600 }}>Business Hours</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {[
                  { day: "Monday – Friday",  hours: "8:00 AM – 6:00 PM",   open: true  },
                  { day: "Saturday",         hours: "9:00 AM – 4:00 PM",   open: true  },
                  { day: "Sunday",           hours: "Closed",               open: false },
                  { day: "Public Holidays",  hours: "Closed",               open: false },
                ].map((row) => (
                  <div key={row.day} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 10, borderBottom: `1px solid rgba(154,202,68,0.08)` }}>
                    <span style={{ fontSize: 13, color: C.textMid }}>{row.day}</span>
                    <span style={{ fontSize: 13, fontWeight: 600, color: row.open ? C.limeGreen : "rgba(16,34,22,0.42)" }}>{row.hours}</span>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 18, display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: C.limeGreen, animation: "pulse 2s infinite" }} />
                {/* <span style={{ fontSize: 12, color: "rgba(230,203,161,0.5)" }}>Support team currently online</span> */}
              </div>
            </div>

            {/* Social links */}
            <div style={{ padding: "24px 28px", border: `1px solid ${C.border}`, borderRadius: 6, background: C.cardBg }}>
              <div style={{ fontSize: 12, letterSpacing: "0.18em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 16, fontWeight: 600 }}>Connect With Us</div>
              <div style={{ display: "flex", gap: 12 }}>
                {[
                  { label: "Facebook",  icon: "f",  href: "#" },
                  { label: "Instagram", icon: "in", href: "#" },
                  { label: "TikTok",    icon: "tt", href: "#" },
                  { label: "YouTube",   icon: "yt", href: "#" },
                ].map((s) => (
                  <a key={s.label} href={s.href} title={s.label} style={{
                    width: 42, height: 42, borderRadius: "50%",
                    background: "rgba(154,202,68,0.08)", border: `1px solid ${C.border}`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 11, fontWeight: 700, color: C.limeGreen, letterSpacing: "0.05em",
                    transition: "background 0.2s, border-color 0.2s",
                  }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(154,202,68,0.18)"; e.currentTarget.style.borderColor = "rgba(154,202,68,0.5)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(154,202,68,0.08)"; e.currentTarget.style.borderColor = C.border; }}>
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════ FAQ STRIP ── */}
      <section style={{ padding: isMobile ? "70px 20px" : "80px 60px", background: "linear-gradient(160deg,#FFFFFF 0%,#EDF6E3 100%)", borderTop: `1px solid ${C.border}` }}
        ref={setRef("faq")} data-section="faq">
        <div style={{ maxWidth: 1180, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 52 }}>
            <div style={sectionTag}>Quick Answers</div>
            <h2 style={{ ...sectionHead, fontSize: "clamp(26px,3vw,40px)" }}>Common <span style={{ color: C.limeGreen, fontStyle: "italic" }}>Questions</span></h2>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 20 }}>
            {[
              { q: "How long does shipping take?",            a: "Standard shipping within the Philippines takes 3–7 business days. We also offer express delivery in select areas." },
              { q: "Do you ship internationally?",           a: "Yes! We currently ship to 28 countries. International delivery times vary between 7–21 business days." },
              { q: "Can I return a product?",                a: "Absolutely. We offer a 30-day satisfaction guarantee. If you're not happy, we'll make it right — no hassle." },
              { q: "Are your products FDA approved?",        a: "All SATP products are registered with the Philippine FDA (Food and Drug Administration) and comply with applicable regulations." },
              { q: "Do you offer wholesale pricing?",        a: "Yes! We have wholesale and reseller programs available. Use the contact form above and select 'Wholesale / Partnership'." },
              { q: "What payment methods do you accept?",   a: "We accept GCash, Maya, major credit/debit cards, bank transfer, and cash on delivery for select areas." },
            ].map((item, i) => (
              <div key={i} style={{
                padding: "26px 28px", border: `1px solid ${C.border}`, borderRadius: 6, background: C.cardBg,
                opacity: visible("faq") ? 1 : 0,
                transform: visible("faq") ? "translateY(0)" : "translateY(20px)",
                transition: `opacity 0.5s ${i * 0.08}s ease, transform 0.5s ${i * 0.08}s ease`,
              }}>
                <div style={{ fontSize: 15, fontWeight: 600, color: C.white, marginBottom: 10, display: "flex", alignItems: "flex-start", gap: 10 }}>
                  <span style={{ color: C.limeGreen, fontSize: 16, marginTop: 1, flexShrink: 0 }}>?</span>
                  {item.q}
                </div>
                <div style={{ fontSize: 14, lineHeight: 1.75, color: C.textFaint, paddingLeft: 26 }}>{item.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════ FOOTER */}
      <footer style={{ background: C.darkGreen, borderTop: `1px solid rgba(154,202,68,0.15)` }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: isMobile ? "36px 20px 24px" : "52px 60px 36px", display: "grid", gridTemplateColumns: isMobile ? "1fr" : isTablet ? "repeat(2,1fr)" : "2fr 1fr 1fr 1fr", gap: isMobile ? 30 : 48 }}>
          {/* Brand col */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <img src={LOGO_SRC} alt="SATP" style={{ height: 44, width: "auto" }} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#FFFFFF", letterSpacing: "0.06em" }}>SYNTROPY</div>
                <div style={{ fontSize: 8, letterSpacing: "0.22em", color: C.limeGreen }}>ALLIANCE TRADE</div>
              </div>
            </div>
            <p style={{ fontSize: 13, lineHeight: 1.7, color: "rgba(230,203,161,0.5)", maxWidth: 240 }}>
              {/* Science-backed wellness products crafted from nature's finest ingredients. */}
              Rooted in Purpose. Growing in Unity. Trading for Good. Powered by Digital Innovation.​
            </p>
          </div>

          {/* Links */}
          {[
            // { title: "Products",  links: ["Health Supplements", "Herbal Blends", "Bundles", "New Arrivals"] },
            // { title: "Company",   links: ["About Us", "Our Science", "Sustainability", "Careers"] },
            { title: "Company",   links: ["About Us"] },
            { title: "Support",   links: ["Contact", "FAQ"] },
          ].map((col) => (
            <div key={col.title}>
              <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 18, fontWeight: 600 }}>{col.title}</div>
              <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 10 }}>
                {
                  col.title === "Company"
                    ? <li key="company__about-us">
                        <a href="#/about" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                          onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                          onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                          About Us
                        </a>
                      </li>
                    : ""
                }

                {
                  col.title === "Support"
                    ? <li key="support__contact">
                        <a href="#/contact" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                          onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                          onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                          Contact
                        </a>
                      </li>
                    : ""
                }
                {
                  col.title === "Support"
                    ? <li key="support__faq">
                        <a href="#/faq" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                          onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                          onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                          FAQ
                        </a>
                      </li>
                    : ""
                }

                {/* BACKUP */}
                {/* {col.links.map((l) => (
                  <li key={l}>
                    <a href="#" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                      onMouseEnter={(e) => (e.target.style.color = C.cream)}
                      onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                      {l}
                    </a>
                  </li>
                ))} */}
              </ul>
            </div>
          ))}
        </div>

        <div style={{ borderTop: `1px solid rgba(154,202,68,0.1)`, padding: isMobile ? "16px 20px" : "20px 60px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <span style={{ fontSize: 12, color: "rgba(230,203,161,0.3)" }}>© 2026 Syntropy Alliance Trade. All rights reserved.</span>
          <div style={{ display: "flex", gap: 24 }}>
            {["Privacy Policy", "Terms of Use", "Refund Policy"].map((l) => (
              <a key={l} href="#" style={{ fontSize: 11, color: "rgba(230,203,161,0.3)", letterSpacing: "0.08em", transition: "color 0.2s" }}
                onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
                onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.3)")}>
                {l}
              </a>
            ))}
          </div>
        </div>
      </footer>

      <style>{`@keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
    </div>
  );
}
